import { CUSTOM_ELEMENTS_SCHEMA, NgModule, inject } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { LoginPageComponent } from "@serasa/core/modules/auth/components/login/login.component";
import { AuthGuard } from "@serasa/core/modules/auth/services/auth.guard";
import { HomePageComponent } from "@serasa/core/pages/home/home.component";
import { DashboardGuard } from "@serasa/core/modules/dashboard/services/dashboard.guard";

const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    redirectTo: "login",
  },
  {
    path: "login",
    component: LoginPageComponent,
  },
  {
    path: "dashboard",
    component: HomePageComponent,
    canActivate: [
      () => {
        inject(AuthGuard).canActivate();
        inject(DashboardGuard).canActivate();
      },
    ],
  },
  {
    path: "revision",
    loadComponent: () =>
      import(
        "./core/modules/accesses-revision/pages/accesses-revision/accesses-revision.page.component"
      ).then((x) => x.AccessesRevisionPageComponent),
    canActivate: [
      () => {
        inject(AuthGuard).canActivate();
        inject(DashboardGuard).canActivate();
      },
    ],
  },
  {
    path: "historico-acoes",
    loadComponent: () =>
      import(
        "./core/pages/actions-history/actions-history.component"
      ).then((x) => x.ActionsHistoryComponent),
    canActivate: [
      () => {
        inject(AuthGuard).canActivate();
        inject(DashboardGuard).canActivate();
      },
    ],
  },  
  {
    path: "recertification",
    loadComponent: () =>
      import("./core/pages/recertification/recertification.component").then(
        (c) => c.RecertificationComponent,
      ),
    canActivate: [
      () => {
        inject(AuthGuard).canActivate();
        inject(DashboardGuard).canActivate();
      },
    ],
  },
  {
    path: "forbidden",
    loadChildren: () =>
      import('./core/modules/forbidden/forbidden.module').then(
        (m) => m.ForbiddenModule,
      ),
  },
  {
    path: "privacy-terms",
    loadChildren: () =>
      import('./core/modules/privacy/privacy.module').then(
        (m) => m.PrivacyModule,
      ),
  },
  {
    path: "**",
    redirectTo: "login",
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppRoutingModule { }
